import { Injectable, OnInit, Directive, Optional, SkipSelf } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { CollapseParentDirective, ParentConfiguration } from './collapse-parent.directive';

@Directive({
  selector: '.collapse-container',
  providers: [ParentConfiguration],
})
export class CollapseContainerDirective implements OnInit {
  private storageKey: string;
  private parentConfig: ParentConfiguration;
  private parent: CollapseParentDirective;
  private collapsed = false;
  private key: string;

  collapseStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private route: ActivatedRoute,
    private storage: LocalStorageService,
    @Optional() @SkipSelf() parentConfig: ParentConfiguration,
  ) {
    this.parentConfig = parentConfig;
  }

  ngOnInit() {
    if (this.parentConfig && this.parentConfig.parent) {
      this.parent = this.parentConfig.parent;
      this.parent.containers.push(this);
      this.collapse(true);
    }
  }

  setHeaderKey(key: string) {
    if (!this.parent) {
      this.key = key;
      let url = '';
      let route = this.route;
      while (route != null && route.routeConfig != null) {
        url = `/${route.routeConfig.path}` + url;
        route = route.parent;
      }
      this.storageKey = `${url}|cards`;
      const data = this.storage.retrieve(this.storageKey);
      if (data) {
        this.collapsed = data[this.key];
        this.collapseStatus.next(this.collapsed);
      }
    }
  }

  toggle() {
    this.collapse(!this.collapsed);
    this.parent?.activate(this);
  }

  collapse(value: boolean) {
    this.collapsed = value;
    if (this.storageKey && this.key) {
      const data = this.storage.retrieve(this.storageKey);
      this.storage.store(this.storageKey, { ...data, [this.key]: this.collapsed });
    }
    this.collapseStatus.next(this.collapsed);
  }
}
